import { render } from "./MenuIcon.vue?vue&type=template&id=0b6f6569"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import "./MenuIcon.vue?vue&type=style&index=0&id=0b6f6569&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__